<template>
	<van-popup v-model="openPopup" position="bottom" :close-on-click-overlay="false">
		<div class="popup-com">
			<div class="popup-header">
				<div class="popup-header-left">
					
				</div>
				<div class="popup-header-middle">提示</div>
				<div class="popup-header-right">
					<i class="iconfont iconguanbi" @click="closePopup"></i>
				</div>
			</div>
			<div class="popup-body popup-pay-stock">
				<div class="popup-pay-stock-text">
					{{ content }}
				</div>
			</div>
			<div class="popup-footer com-btn-contanier">
				<div class="com-btn com-btn-no" @click="closePopup">取消</div>
				<div class="com-btn com-btn-ok" @click="confirm">确认</div>
			</div>
		</div>
	</van-popup>
</template>

<script>
import popupMixin from "@/mixins/popupMixin";
import javaApi from "@/api/javaApi";

export default {
	props: ["content"],
	mixins: [ popupMixin ],
	methods: {
		async confirm(){
			this.closePopup();
			this.$emit('confirmEvent');
		}
	}
}
</script>

<style lang="less" scoped>
.popup-com{
	.popup-pay-stock{
		padding: 24px 15px 0 15px;
		text-align: left;
		display: flex;
		flex-direction: column;
		justify-content: center;
		&-title{
			font-size: 16px;
			color: #1D1D1D;
			margin-top: 10px;
		}
		&-text{
			padding: 10px 0 20px;
			text-align: center;
			font-size: 16px;
			color: #666666;
		}
	}
}
</style>